import { RegionWithData } from '@/app/db/queries/regions'
import { CatalogType, Region } from '@prisma/client'
import { DonorWithData } from '../db/queries/donors'
import {
  DonorRegionOocytesProgramWithData,
  DonorRegionVialsProgramWithData
} from '../db/queries/donor-region-oocytes-programs'

export type DonorRegionDataType = {
  oocytesAvailable: number
  vialsAvailable: number
  published: boolean
  private: boolean
  oocytesPrograms: DonorRegionOocytesProgramWithData[]
  vialsPrograms: DonorRegionVialsProgramWithData[]
} | null

export const getRegionByDonor = (
  donor: Partial<DonorWithData>,
  regionId?: number | null
) => {
  return donor?.donorRegions?.find((item) => item.regionId === regionId)
}

export const getRegionDataByDonor = (
  donor: Partial<DonorWithData>,
  region?: Region | RegionWithData | null
) => {
  if (!donor || !region) {
    return null
  }

  const groupId = region?.groupId

  const donorRegion = donor.donorRegions?.find(
    (item) => item.regionId === region.id
  )

  if (groupId) {
    const donorRegionGroup = donor.donorRegionGroups?.find(
      (item) => item.groupId === groupId
    )

    const donorRegion = donor.donorRegions?.find(
      (item) => item.regionId === region.id
    )
    if (donorRegionGroup && donorRegion) {
      return {
        oocytesAvailable: donorRegionGroup.oocytesAvailable,
        vialsAvailable: donorRegionGroup.vialsAvailable,
        published: donorRegion.published,
        private: donorRegion.private,
        oocytesPrograms: donorRegion.oocytesPrograms,
        vialsPrograms: donorRegion.vialsPrograms
      }
    }
  }

  if (donorRegion) {
    return {
      oocytesAvailable: donorRegion.oocytesAvailable,
      vialsAvailable: donorRegion.vialsAvailable,
      published: donorRegion.published,
      private: donorRegion.private,
      oocytesPrograms: donorRegion.oocytesPrograms,
      vialsPrograms: donorRegion.vialsPrograms
    }
  }

  return null
}

export const INTERNATIONAL_REGION_ID = {
  [CatalogType.OOCYTE]: 'international',
  [CatalogType.SPERM]: 'sperm_international',
  [CatalogType.EMBRYO]: 'embryo_international',
  [CatalogType.IFG]: 'ifg_international'
}
